import { AddProjectContentItemInput } from '@deltek/specification-client/core/Models/projectProductProperty'
import { TextContentElement } from '@deltek/specification-client/core/Models/textContentElement'
export enum BestPracticeSyncAction {
    Null = 'Null',
    None = 'NONE', // UI is already in sync with the latest BP version
    SyncFromBP = 'SYNCFROMBP', // Update UI elements to match the latest BP version
    CreateNewBP = 'CREATENEWBP', // Create a new BP version from the UI changes
}
export interface SyncActionResult {
    action: BestPracticeSyncAction
    message: string
    latestVersionId: string
    currentVersionId: string
    isUserAddedContentBestPractice: boolean
}
export interface BestPracticeDataExtended {
    id: string
    firmId: string
    isGlobal: boolean
    location: any
    projectGroup: string
    parameters: any
    parentProjectId: string
    projectElementNodeId: string
    elements: Partial<Elements>[]
    currentVersionId?: string
    contentItemId?: any
    isUserAddedContentBestPractice?: boolean
    isHidden?: boolean
}
export interface BestPracticeDataResponseExtended {
    getBestPractice: BestPracticeDataExtended
}
export interface AddUpdateBestPracticeResponseExtended {
    addUpdateBestPractice: BestPracticeDataExtended[]
}
export interface Elements extends Partial<TextContentElement> {
    userAddedContentBP: Partial<AddProjectContentItemInput>
}
